import ArticleCard from "@/components/articleCard";
import { Article } from "@/graphql/gql/graphql";
import styles from "./relatedArticles.module.scss";

interface RelatedArticlesProps {
  articles: Article[];
  title?: string;
}
const RelatedArticles = ({
  articles,
  title = "More Articles You May Like",
}: RelatedArticlesProps) => {
  if (!articles || articles.length < 2) {
    return <div />;
  }

  return (
    <div>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.container}>
        {articles?.map((article) => (
          <ArticleCard
            key={article.id}
            author={article.author}
            image={article.hero?.imageUrl?.url}
            link={article.slug}
            origin="related_articles"
            publishedOn={article.firstPublishedAt}
            sportName={article.sport.name}
            sportSlug={article.sport.slug}
            title={article.title}
            description={article.description}
            addBackground
          />
        ))}
      </div>
    </div>
  );
};
export default RelatedArticles;
